import "./App.css";
import Home from "./Pages/Home";
import "@fontsource-variable/readex-pro";

function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
